import {
  Button,
  Field,
  CellGroup,
  CheckboxGroup,
  Checkbox,
  Icon,
  Uploader,
  Form,
  Stepper,
  Popup,
  Picker,
  List,
  PullRefresh,
  PickerGroup,
  DatePicker,
  Dialog,
  Tab,
  Tabs,
  Badge,
  DropdownMenu,
  DropdownItem,
  RadioGroup,
  Radio,
  Collapse,
  CollapseItem,
} from 'vant';
import 'vant/lib/index.css';

const components = [
  Button,
  Field,
  CellGroup,
  CheckboxGroup,
  Checkbox,
  Icon,
  Uploader,
  Form,
  Stepper,
  Popup,
  Picker,
  List,
  PullRefresh,
  PickerGroup,
  DatePicker,
  Dialog,
  Tab,
  Tabs,
  Badge,
  DropdownMenu,
  DropdownItem,
  RadioGroup,
  Radio,
  Collapse,
  CollapseItem,
];
export default function vant(app) {
  components.forEach((component) => {
    app.use(component);
  });
}
